import React, { Component } from 'react';
import './App.css';
import Navigation from './Navigation.js'
import Footer from './Footer.js'


class Contact extends Component {
  
  render() {
    return (
        <div>
            <header>
            <img src="/img/matrix-row-reduction-calculator-logo.png" className="logo" alt="Matrix Row Reduction Calculator" />
            <a href="/" className="logo-title">Matrix Row Reduction Calculator</a>
                <nav className="menu">
                    <Navigation />
                </nav>
            </header>
                <div className="section">
                <h1>Contact Us</h1>
                <p>If you have any questions or business inquiries, contact us at <b>contact@matrixrowreductioncalculator.com</b></p>
                </div>
            <Footer />
         </div>
    );
  }
}

export default Contact;